import React from 'react'
import { Button, Container } from 'reactstrap'
import styles from './SiteRetired.module.scss'

const SiteRetired = ({ message }) => (
  <div className={styles.siteRetired}>
    <Container className={styles.content}>
      <img className='mb-2' src='school-booking-logo.svg' alt='School Booking Logo' width='150' />
      <h1>We've Moved!</h1>
      <h3>Parents' Meetings are now available on our new website. Please click the button below to continue.</h3>
      <Button size='lg' className={styles.button} color='primary' href='https://beta.events.schoolbooking.com'>
        Go To New Parents Meetings
      </Button>
    </Container>
  </div>
)

export default SiteRetired
